import FolderInput from './FolderInput';

export default FolderInput;
